import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function avisoFinSessionReducer(state= initialState.showModalAvisoFinSession, action){
	
	switch(action.type){
		case types.SHOW_MODAL_FIN_SESSION:
			
			return true;
		break;
		
		case types.RENOVAR_SESSION:
			return false;
		break;
			
		default:
			return state;
	}
}